<template>
  <div>
    <a-card title="IP信息">
      <template slot="extra">
        <a-button type="primary" icon="reload" @click="getIp">刷新</a-button>
      </template>
      <a-descriptions title="从国内测试">
        <a-descriptions-item label="IP">{{ ipinfo.china.query }} <a-spin v-if="isLoading"></a-spin></a-descriptions-item>
        <a-descriptions-item label="地域">{{ ipinfo.china.country }} / {{ ipinfo.china.city }} <a-spin v-if="isLoading"></a-spin></a-descriptions-item>
        <a-descriptions-item label="运营商">{{ ipinfo.china.isp }} <a-spin v-if="isLoading"></a-spin></a-descriptions-item>
      </a-descriptions>
    </a-card>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'ip',
  data () {
    return {
      isLoading: false,
      ipinfo: {
        china: {
          country: '',
          city: '',
          isp: '',
          org: ''
        }
      }
    }
  },
  methods: {
    getIp () {
      this.isLoading = true
      axios.get('https://www.zerofast.net/ip.php?type=json').then(res => {
        this.ipinfo.china = res.data
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.getIp()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/IP.vue